import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// O CSS do site é um tailwind já compilado (public/assets/css/tailwind.css):
// classe que nenhuma outra página usa não existe nele. Por isso as listas
// levam o marcador no style, e não em list-disc.
const titulo = 'mb-4 mt-12 text-2xl font-bold text-dark'
const paragrafo = 'mb-4 text-base leading-relaxed text-body-color'
const lista = { listStyle: 'disc', paddingLeft: 20 }

const EMAIL = 'comercial@entregaja.com.br'

export default function Privacidade() {
    return (
        <>
            <Header />
            <div className="relative z-10 overflow-hidden bg-primary pt-[120px] pb-[100px] md:pt-[130px] lg:pt-[160px]">
                <div className="container">
                    <div className="-mx-4 flex flex-wrap items-center">
                        <div className="w-full px-4">
                            <div className="text-center">
                                <h1 className="text-4xl font-semibold text-white">Política de Privacidade</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="bg-[#f3f4fe] pt-20 pb-20 lg:pt-[120px] lg:pb-[120px]">
                <div className="container">
                    <div className="mx-auto max-w-[850px] border bg-white py-12 px-7 sm:px-12 md:p-16">
                        <p className="mb-4 text-sm text-body-color">Atualizada em 17 de outubro de 2026</p>

                        <p className={paragrafo}>
                            Esta política explica como a Entrega Já trata os dados pessoais de quem usa o nosso site,
                            fala com a gente pelo WhatsApp ou por e-mail, pede cotação, contrata ou acompanha um
                            transporte. Ela segue a Lei Geral de Proteção de Dados (Lei nº 13.709/2018, a LGPD).
                        </p>

                        <h2 className={titulo}>1. Quem somos</h2>
                        <p className={paragrafo}>
                            A controladora dos dados é a <strong>ENTREGA JA LOGISTICA E SERVICOS LTDA</strong>,
                            CNPJ 27.069.620/0001-33, com sede na Av. Santos Dumont, 66, Anil, São Luís/MA,
                            CEP 65046-660, e suas filiais. Para qualquer assunto sobre os seus dados, escreva
                            para <a href={`mailto:${EMAIL}`} className="text-primary">{EMAIL}</a>.
                        </p>

                        <h2 className={titulo}>2. Quais dados coletamos</h2>
                        <ul style={lista} className={paragrafo}>
                            <li>
                                <strong>Formulários do site</strong> (contato, atendimento e cotação): nome da empresa,
                                nome do representante, e-mail, telefone/WhatsApp, a mensagem e os dados da carga que você
                                informar, como origem, destino, peso e volume.
                            </li>
                            <li>
                                <strong>Consulta de pedidos</strong>: o CPF ou CNPJ e o número do documento que você digita
                                para rastrear uma entrega.
                            </li>
                            <li>
                                <strong>WhatsApp</strong>: o seu número, o nome do seu perfil, as mensagens que você envia e
                                o que vier junto com elas (áudios, que transcrevemos em texto, imagens, documentos, vídeos,
                                localização e contatos), além dos avisos de entrega e de leitura das nossas mensagens.
                            </li>
                            <li>
                                <strong>E-mail</strong>: o endereço, o conteúdo e os anexos das mensagens trocadas conosco.
                            </li>
                            <li>
                                <strong>Contratação e execução do transporte</strong>: os dados de remetente, destinatário e
                                pagador que aparecem nas notas fiscais, nos conhecimentos de transporte (CT-e) e nos
                                comprovantes de entrega.
                            </li>
                            <li>
                                <strong>Contato comercial</strong>: nome, empresa, cargo, e-mail e telefone profissionais
                                obtidos em fontes públicas ou em plataformas de negócios e de frete, usados para apresentar
                                os nossos serviços a empresas e profissionais.
                            </li>
                            <li>
                                <strong>Navegação no site</strong>: cookies e ferramentas de medição (Google Analytics e
                                Google Tag Manager, Meta Pixel e Microsoft Clarity), que registram páginas visitadas, origem
                                do acesso, dispositivo e interações como cliques e rolagem.
                            </li>
                        </ul>

                        <h2 className={titulo}>3. Para que usamos</h2>
                        <ul style={lista} className={paragrafo}>
                            <li>Fazer cotações, contratar e executar o transporte e emitir os documentos fiscais.</li>
                            <li>Informar o andamento e a entrega das cargas e responder às suas solicitações.</li>
                            <li>Prestar atendimento pelo WhatsApp, por e-mail e por telefone.</li>
                            <li>Apresentar os nossos serviços a empresas e profissionais que possam ter interesse neles.</li>
                            <li>Entender como o site é usado e melhorá-lo.</li>
                            <li>Cumprir obrigações legais, fiscais e regulatórias, prevenir fraudes e proteger nossos direitos.</li>
                        </ul>

                        <h2 className={titulo}>4. Bases legais</h2>
                        <p className={paragrafo}>
                            Tratamos dados para executar o contrato de transporte e os passos que vêm antes dele, como a
                            cotação; para cumprir obrigações legais e regulatórias; pelo nosso legítimo interesse, no
                            contato comercial com empresas e na melhoria dos serviços, sempre respeitando os seus direitos
                            e a sua expectativa; e, quando a lei exigir, com o seu consentimento, que pode ser revogado a
                            qualquer momento.
                        </p>

                        <h2 className={titulo}>5. WhatsApp</h2>
                        <p className={paragrafo}>
                            Usamos a Plataforma WhatsApp Business, a API oficial da Meta. As mensagens passam pela
                            infraestrutura da Meta e também estão sujeitas aos termos e à política de privacidade do
                            WhatsApp. Parte das nossas respostas é escrita com apoio de inteligência artificial, sempre sob
                            acompanhamento da nossa equipe; se preferir falar com uma pessoa, é só pedir na conversa.
                        </p>
                        <p className={paragrafo}>
                            Se não quiser mais receber mensagens nossas, responda pedindo para parar ou toque
                            em "Agora não" quando a opção aparecer. Registramos o seu pedido e não voltamos a procurar você.
                        </p>

                        <h2 className={titulo}>6. Com quem compartilhamos</h2>
                        <p className={paragrafo}>
                            Não vendemos dados pessoais. Compartilhamos apenas o necessário com:
                        </p>
                        <ul style={lista} className={paragrafo}>
                            <li>a Meta, que opera o WhatsApp;</li>
                            <li>
                                fornecedores de tecnologia que trabalham para nós: hospedagem e servidores, sistema de gestão
                                de transportes, gestão de relacionamento com clientes (CRM), e-mail corporativo, inteligência
                                artificial e ferramentas de medição do site;
                            </li>
                            <li>parceiros de transporte e de redespacho, quando a entrega precisar deles;</li>
                            <li>autoridades públicas, quando a lei ou uma ordem judicial exigir.</li>
                        </ul>
                        <p className={paragrafo}>
                            Alguns desses fornecedores guardam dados fora do Brasil. Nesses casos, a transferência segue o
                            que a LGPD permite, com contratos e garantias de proteção adequados.
                        </p>

                        <h2 className={titulo}>7. Por quanto tempo guardamos</h2>
                        <p className={paragrafo}>
                            Guardamos os dados pelo tempo necessário para as finalidades acima. Documentos fiscais e de
                            transporte ficam pelo prazo que a lei exige. Conversas de atendimento e dados de contato
                            comercial ficam enquanto houver relacionamento ou até você pedir a exclusão. Depois disso, os
                            dados são apagados ou anonimizados.
                        </p>

                        <h2 className={titulo}>8. Segurança</h2>
                        <p className={paragrafo}>
                            Usamos conexões criptografadas, acesso restrito às pessoas que precisam dos dados para trabalhar
                            e controle de quem entra em cada sistema. Nenhum sistema é totalmente imune a incidentes; se
                            algum afetar os seus dados, avisaremos você e a Autoridade Nacional de Proteção de Dados (ANPD),
                            como a lei determina.
                        </p>

                        <h2 className={titulo}>9. Seus direitos</h2>
                        <p className={paragrafo}>
                            Você pode pedir, a qualquer momento: a confirmação de que tratamos seus dados e o acesso a eles;
                            a correção de dados errados ou desatualizados; a anonimização, o bloqueio ou a eliminação de dados
                            desnecessários ou tratados em desacordo com a lei; a portabilidade; a informação sobre com quem
                            compartilhamos; a revogação do consentimento; e opor-se a um tratamento. Também pode reclamar à
                            ANPD. Para exercer qualquer um desses direitos, escreva
                            para <a href={`mailto:${EMAIL}`} className="text-primary">{EMAIL}</a>.
                        </p>

                        <h2 id="exclusao-de-dados" className={titulo}>10. Como pedir a exclusão dos seus dados</h2>
                        <ol style={{ listStyle: 'decimal', paddingLeft: 20 }} className={paragrafo}>
                            <li>
                                Envie um e-mail para <a href={`mailto:${EMAIL}`} className="text-primary">{EMAIL}</a> com
                                o assunto "Exclusão de dados".
                            </li>
                            <li>
                                Informe o número de WhatsApp, o e-mail ou o CPF/CNPJ que você usou com a gente, para
                                localizarmos os seus dados.
                            </li>
                            <li>
                                Podemos pedir uma confirmação de que o pedido é seu. Em até 15 dias apagamos os dados das
                                nossas conversas e cadastros e respondemos confirmando.
                            </li>
                        </ol>
                        <p className={paragrafo}>
                            Dados que a lei nos obriga a guardar, como documentos fiscais e de transporte, ficam guardados
                            só pelo prazo legal e só para essa finalidade.
                        </p>

                        <h2 className={titulo}>11. Crianças e adolescentes</h2>
                        <p className={paragrafo}>
                            Nossos serviços são voltados a empresas e a adultos. Não coletamos de propósito dados de
                            menores de 18 anos.
                        </p>

                        <h2 className={titulo}>12. Mudanças nesta política</h2>
                        <p className={paragrafo}>
                            Podemos atualizar esta política. A data no topo mostra a versão em vigor; mudanças importantes
                            serão avisadas no site.
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
